<template>
  <q-page class="flex flex-center q-pa-md">
    <div class="n-masonry" :style="'column-count:' + (user.apps.length > 3 ? 4 : user.apps.length)">
      <div v-for="(app, appKey) in user.apps" :key="appKey" class="n-masonry-panel">
        <q-card>
          <q-card-section>
            <div class="row items-center justify-center no-wrap q-gutter-sm q-mb-md">
              <img v-if="app.logo" :src="app.logo" style="max-width: 150px; max-height: 35px" />
              <div v-if="app.title" class="text-h5">{{ app.title }}</div>
            </div>

            <div class="column items-stretch q-gutter-md">
              <q-btn
                v-for="(item, itemKey) in app.items"
                :key="itemKey"
                :label="item.label"
                :href="item.url"
                type="a"
                target="_blank"
                no-caps
                class="bg-grey-2 text-primary"
                unelevated />
            </div>
          </q-card-section>
        </q-card>
      </div>
    </div>
  </q-page>
</template>

<script setup>
import { user } from 'src/njs/boot/user.js'
</script>

<style lang="scss">
.n-masonry {
  // column-count: 4; // определяем в шаблоне
  column-gap: 0;

  .n-masonry-panel {
    break-inside: avoid;
    padding: 10px;
  }

  @media (width <= 800px) {
    column-count: 2 !important;
  }

  @media (width <= 600px) {
    column-count: 1 !important;
  }
}
</style>
